import BenchmarkScoreService from 'src/modules/benchmarkScore/benchmarkScoreService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'BENCHMARKSCORE_VIEW';

const benchmarkScoreViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: benchmarkScoreViewActions.FIND_STARTED,
      });

      const record = await BenchmarkScoreService.find(id);

      dispatch({
        type: benchmarkScoreViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: benchmarkScoreViewActions.FIND_ERROR,
      });

      getHistory().push('/benchmark-score');
    }
  },
};

export default benchmarkScoreViewActions;
